import { render, staticRenderFns } from "./ClientCharts.vue?vue&type=template&id=6bb569b6"
import script from "./ClientCharts.vue?vue&type=script&lang=js"
export * from "./ClientCharts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports